import React, { Component } from "react";
import node from "../img/node.png";
import react from "../img/react.png";
import html from "../img/html.png";
import css from "../img/css.png";
import shadow from "../img/shadow.png";
import styles from "./Cube.module.scss";

import * as THREE from "three";
class Cube extends Component {
  componentDidMount() {
    // === THREE.JS CODE START ===
    var scene = new THREE.Scene();

    var camera = new THREE.PerspectiveCamera(
      65, //fov
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    camera.position.set(0, 0.5, 2);
    camera.lookAt(0, 0, 0);
    var renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight, false);
    this.mount.appendChild(renderer.domElement);
    const loader = new THREE.TextureLoader();

    /* shadow */
    const planeSize = 0.5;
    const shadowGeo = new THREE.PlaneBufferGeometry(planeSize, planeSize);
    const shadowTexture = loader.load(shadow);

    const base = new THREE.Object3D();
    scene.add(base);
    const shadowMat = new THREE.MeshBasicMaterial({
      map: shadowTexture,
      transparent: true, // so we can see the ground
      depthWrite: false, // so we don't have to sort
    });
    const shadowMesh = new THREE.Mesh(shadowGeo, shadowMat);
    shadowMesh.position.y = -1; // so we're above the ground slightly
    shadowMesh.rotation.x = Math.PI * -0.5;
    const shadowSize = 1 * 4;
    shadowMesh.scale.set(shadowSize, shadowSize, shadowSize);
    scene.add(shadowMesh);

    /* light */
    {
      const color = 0xffffff;
      const intensity = 1.5;
      const light = new THREE.DirectionalLight(color, intensity);
      light.castShadow = false;
      light.position.set(-1, 2, 4);

      scene.add(light);
    }

    /* box */
    const materials = [
      new THREE.MeshPhongMaterial({
        map: loader.load(react),
        side: THREE.DoubleSide,
      }),
      new THREE.MeshPhongMaterial({
        map: loader.load(node),
        side: THREE.DoubleSide,
      }),
      /* top */
      new THREE.MeshPhongMaterial({
        color: 0x33aa55,
        side: THREE.DoubleSide,
      }),
      /* bottom */
      new THREE.MeshPhongMaterial({
        color: 0x33aa55,
        side: THREE.DoubleSide,
      }),
      new THREE.MeshPhongMaterial({
        map: loader.load(css),
        side: THREE.DoubleSide,
      }),
      new THREE.MeshPhongMaterial({
        map: loader.load(html),
        side: THREE.DoubleSide,
      }),
    ];
    var geometry = new THREE.BoxGeometry(2, 2, 2);
    var cube = new THREE.Mesh(geometry, materials);
    base.add(cube);

    /* animation */
    camera.position.z = 3;
    var animate = function () {
      requestAnimationFrame(animate);
      cube.rotation.y += 0.01;
      renderer.render(scene, camera);
    };
    animate();
    // === THREE.JS EXAMPLE CODE END ===
  }
  render() {
    return (
      <div
        className={styles.Cube}
        ref={(mount) => {
          this.mount = mount;
        }}
      />
    );
  }
}
export default Cube;
